import clsx from "clsx";
import React, { useEffect, useState } from "react";

type SectionTitleProps = {
  title: string;
  isOpen?: boolean;
  onClick?: () => void;
  disabled?: boolean;
  isAlwaysOpen?: boolean;
};

function SectionTitle({
  title,
  isOpen = false,
  onClick,
  disabled,
  isAlwaysOpen,
}: SectionTitleProps) {
  return (
    <div
      className={clsx("h3", {
        "text-black-tint-70": disabled,
        "cursor-pointer": !disabled && !isAlwaysOpen,
      })}
      onClick={onClick}
      data-testid="toggle-section-button"
    >
      {isAlwaysOpen ? null : (
        <span className="body-s mr3">{isOpen && !disabled ? "\u25bc" : "\u25b6"} </span>
      )}
      {title}
    </div>
  );
}

type SectionProps = {
  title: string;
  children?: React.ReactElement;
  isInitiallyOpen?: boolean;
  isAlwaysOpen?: boolean;
  disabled?: boolean;
  dataTestId?: string;
  id?: string;
};

function Section({
  title,
  children,
  isAlwaysOpen = false,
  isInitiallyOpen = false,
  disabled = false,
  dataTestId = "",
  id = "",
}: SectionProps) {
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    if (isInitiallyOpen) setIsOpen(true);
  }, [isInitiallyOpen]);

  const className = clsx("text-black", "inline", isAlwaysOpen ? "p4" : "p2");

  if (disabled)
    return (
      <div className={className} data-testid={dataTestId || title} id={id}>
        <SectionTitle title={title} disabled />
      </div>
    );
  return (
    <div className={className} data-testid={dataTestId || title} id={id}>
      <SectionTitle
        title={title}
        onClick={isAlwaysOpen ? undefined : handleClick}
        isOpen={isAlwaysOpen ? true : isOpen}
        isAlwaysOpen={isAlwaysOpen}
      />
      {isOpen || isAlwaysOpen ? <div className="py4">{children}</div> : null}
    </div>
  );

  function handleClick() {
    setIsOpen(!isOpen);
  }
}

export { SectionTitle, Section };
